export const domReady = (callback: CallableFunction): void => {
  if (['interactive', 'complete'].includes(document.readyState)) {
    callback();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      callback as EventListenerOrEventListenerObject
    );
  }
};
